export default __webpack_public_path__ + "static/upper3_3-d2eeee824746151ac0dafa1bc4dfaac4.jpg";